let getMomentDate = (date, ignoreTZ=false)=>{
    date = moment.tz(date, 'UTC');
    if(ignoreTZ===false) {
        // Converte o fuso em vez de subtrair horas: subtrair muda o instante e quebra o fromNow()
        date.tz('America/Sao_Paulo');
    }
    return date
};

import { plans_features, companiesOfFidelityProgram } from './consts.js';
import pipes from './hoop-common-js/store/modules/pipes/pipes.js';
import { applyTotalToDiscount as applyTotalToDiscountUtil } from './Utils/discount-calc-util.js';

function getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}

const mix_general = {

	created: function () {
        const pageTitle = getTitle(this)
        if (pageTitle) {
          document.title = pageTitle
        }
	},

	filters: {
		limitText(text, max){
			return (text ? text.slice(0, max) + (text.length > max ? "..." : "") : '');
		},

		fromNow: function (date, ignoreTZ=false) {
			if(date) {
				return getMomentDate(date, ignoreTZ).fromNow();
			} else {
				return '';
			}
		},

        trimmer: function (text) {
            return text.trim();
        },        

		inBrDate: function(date, ignoreTZ=false) {
			return (date ? getMomentDate(date, ignoreTZ).format('L') : 'Não informado');
		},

		inBrDateWithHour: function(date, ignoreTZ=false) {
			if (!date) {
				return 'Não informado';
			}
			date = getMomentDate(date, ignoreTZ);
			if (!date.isValid()) {
				return 'Não informado';
			}
			return date.format('L') + " " + date.format('LT');
		},

		inBrDateMDY: function(date, ignoreTZ=false) {
			return getMomentDate(date, ignoreTZ).format("MMM DD, YYYY");
		},
        timeOfDate(date){
            if(date){
                let splitted = date.split(' ');
                if(splitted.length>1)
                    return splitted[1];
            }
            return 'Não informado';
        },
		productType: function (type) {

			switch (type) {
				case 'simple':
					return 'Simples';
					break;
				case 'configurable':
					return 'Configurável com variações';
					break;
				case 'child':
					return 'Variação';
					break;
			}

		},
        roleArch: function (role) {
            switch (role) {
                case 'superadmin':
                    return 'Sócio';
                    break;
                case 'admin':
                    return 'Administrador';
                    break;
                case 'manager':
                    return 'Gerente';
                    break;
                case 'seller':
                    return 'Funcionário';
                    break;
                case 'architect':
                    return 'Arquiteto';
                    break;
                case 'financial':
                    return 'Financeiro';
                    break;
            }
        },

		role: function (role) {

			switch (role) {
				case 'superadmin':
					return 'Super Administrador';
					break;
				case 'admin':
					return 'Administrador';
					break;
				case 'manager':
					return 'Gerente';
					break;
				case 'seller':
					return 'Vendedor';
					break;
				case 'architect':
					return 'Arquiteto';
					break;
			}

		},
		status: function (status) {

            switch (status) {
                case 'open':
                    return 'Aberto';
                    break;
                case 'lost':
                    return 'Perdido';
                    break;
                case 'won':
                    return 'Ganho';
                    break;
                case 'in_progress':
                    return 'Aberto';
                    break;
                case 'canceled':
                    return 'Cancelado';
                    break;
                case 'closed':
                    return 'Venda efetuada';
                    break;
            }

        },
		unit: function (unit) {

            switch (unit) {
                case 'unid':
                    return 'unidade(s)';
                    break;
                case 'caixas':
                    return 'caixa(s)';
                    break;
                case 'cm':
                    return 'centímetro(s)';
                    break;
                case 'cm2':
                    return 'centímetro(s) quadrado(s)';
                    break;
                case 'cm3':
                    return 'centímetro(s) cúbico(s)';
                    break;
                case 'm':
                    return 'metro(s)';
                    break;
                case 'm2':
                    return 'metro(s) quadrado(s)';
                    break;
                case 'm3':
                    return 'metro(s) cúbico(s)';
                    break;
                case 'L':
                    return 'litro(s)';
                    break;
            }

        },

		projectSituation:function (situation){
            switch (situation) {
                case 'running':
                    return 'Em Andamento';
                    break;
                case 'paralysed':
                    return 'Paralisado';
                    break;
            }
		},
		projectStep:function (step){
            switch (step) {
                case 'pre-order':
                    return 'Pré Venda';
                    break;
            }
		},

        inBrHour(value){
        	value = value.split(":");
        	return value[0] + "h" + value[1] + "min";
        },

        

		toBrl(value, toFixed = 2){
			if(value !== null && value !== undefined && value !== '') {
                const num = parseFloat(value);
                const isNegative = num < 0;
                let val = Math.abs(num).toFixed(toFixed).toString().replace('.', ',');
                if(toFixed>0)
                    var newVal = ','+val.split(",")[1];
                else
                    var newVal = '';
                var charCount=-1;
                const intPart = val.split(",")[0];
                for(let char of intPart.split("").reverse().join("")){
                    if(charCount ===2){
                        newVal = '.'+newVal;
                        charCount=0;
                    }else{
                        charCount++;
                    }
                    newVal = char+newVal;
                }
                return isNegative ? '-'+newVal : newVal;
            }
			return "0,00";
		},

        toBrl2(value){
            if(value !== null && value !== undefined && value !== '') {
                const num = parseFloat(value);
                const isNegative = num < 0;
                let val = Math.abs(num).toFixed(1).toString().replace('.', ',');
                var newVal = ','+val.split(",")[1];
                var charCount=-1;
                const intPart = val.split(",")[0];
                for(let char of intPart.split("").reverse().join("")){
                    if(charCount ===2){
                        newVal = '.'+newVal;
                        charCount=0;
                    }else{
                        charCount++;
                    }
                    newVal = char+newVal;
                }
                return isNegative ? '-'+newVal : newVal;

            }
            return "0,0";
        },

        toFormattedDiscount(value, type){
            if(type === 'percent' || type===1)
                return value + "%";
            else
                return "{{ companyCurrency() }} "+ value
        },

		titleCase(str) {
		    return str.replace(/(?:^|\s)\w/g, function(match) {
		        return match.toUpperCase();
		    });
		},

		urlToString(val){
			return val.toUpperCase().replace(/-/g,' ');
		},
		uppercase(val){
			return val.toUpperCase();
		},
		toAddress(val){
			return ((!val.address && (val.number === "0") && !val.city && !val.state) ? "" : val.address+", "+val.number+(val.complement ? " / "+val.complement : "")+((val.city || val.state) ? " - " : "")+(val.city ? val.city+", " : "")+(val.state ? val.state : ""));
		},
		asServiceSupplier(val){
			if(val.toUpperCase() === 'FABRICANTE NÃO INFORMADO'){
				return 'Prestador não informado';
			}
			else{
				return val;
			}
		},
	},

	methods: {
        formatDate(date){
            return getMomentDate(date, true).format("YYYY-MM-DD");
        },
	    sendToQueue(funcNames, cb, params){
	        queue.push(this, funcNames, cb, params);
            //console.log('sendToQueue')
        },
	    removeReactivity(val){
            return JSON.parse(JSON.stringify(val))
        },
	    arrayMove(arr0, old_index, new_index){
	        var arr = JSON.parse(JSON.stringify(arr0));
            while (old_index < 0) {
                old_index += arr.length;
            }
            while (new_index < 0) {
                new_index += arr.length;
            }
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr;
        },
        externalCatalogFilters(filters){
            if (this.$route.params.id) {
                filters.category = this.$route.params.id;
                filters.onlyFavorites = false;
            } else {
                filters.category = '';
                filters.onlyFavorites = true;
            }
            //filtra só para os que são do album da url
            if (this.$route.params.album_id) {
                filters.from = '';
                filters.album_id = this.$route.params.album_id;
                filters.onlyFavorites = false;
                filters.includeHidden = true;
            }
            //filtros para os projetos
            if (window.location.host.slice(0,8) == "projetos") { //caso for uma págino do tipo projetos.loja
                if(this.$route.fullPath.indexOf("projetos")!==-1 || this.$route.fullPath.indexOf("solicitar-convite")!==-1){
                    filters.sortBy = "custom_products_count";
                } else if(this.$route.fullPath.indexOf("consultores")!==-1 || this.$route.fullPath.indexOf("arquitetos")!==-1){
                    filters.sortBy = "detailed_albums_count";
                }
            } else if(this.$route.fullPath.indexOf("projetos")!==-1 || this.$route.fullPath.indexOf("solicitar-convite")!==-1){
                    //caso em que a página é do tipo hoopdecor.com/loja
                    filters.sortBy = "custom_products_count";
                } else if(this.$route.fullPath.indexOf("consultores")!==-1 || this.$route.fullPath.indexOf("arquitetos")!==-1){
                    filters.sortBy = "detailed_albums_count";
                } else{
                filters.sortBy = 'created_at';
            }
            //sortBy e sortDirection
            if(this.$route.query.sort){
                filters.sortBy = this.$route.query.sort;
            } else if(this.$route.query.dir){
                filters.sortBy = this.$route.query.dir;
            }
            return filters;
        },
        filterItems: function(array, fields, query) {
            if(!query) {
                return array;
            } else {
                return array.filter(function(item) {
                    let regex = new RegExp(query, 'i');
                    return fields.some(field => item[field] && item[field].toString().match(regex));
                })
            }
        },
        

        /**
         * Corrige URLs de imagem com barras escapadas (\/) ou duplicadas (//),
         * geradas por json_encode / parse incorreto — o browser trata \/ como //
         * e o S3 responde NoSuchKey (ex.: /uploaded_files//arquivo.png).
         */
        normalizeAssetUrl(url) {
            if (!url || typeof url !== 'string') {
                return url;
            }
            url = url.replace(/\\/g, '/');
            return url.replace(/^(https?:)\/+/i, '$1//').replace(/([^:])\/{2,}/g, '$1/');
        },
        sanitizeImageUrls(image) {
            if (!image || typeof image !== 'object') {
                return image;
            }
            const fields = ['thumbsq', 'thumb', 'display', 'original', 'file_path'];
            fields.forEach((field) => {
                if (typeof image[field] === 'string') {
                    image[field] = this.normalizeAssetUrl(image[field]);
                }
            });
            return image;
        },
        noProductImageUrl() {
            return 'https://hoopdecor.s3.sa-east-1.amazonaws.com/static/production/img/produto-sem-imagem.gif';
        },
        getThumb(product) {
            const notAmbient = img => img && img.type !== 'ambient';
            const ownImages = (product.images || []).filter(notAmbient);
            if(ownImages.length>0) {
                return this.normalizeAssetUrl(ownImages[0].thumbsq) || this.noProductImageUrl();
            }
            const productImages = ((product.product && product.product.images) || []).filter(notAmbient);
            if(productImages.length>0){
                return this.normalizeAssetUrl(productImages[0].thumbsq) || this.noProductImageUrl();
            }
            const sharedImages = (product.shared_images || []).filter(notAmbient);
            if(sharedImages.length>0){
                return this.normalizeAssetUrl(sharedImages[0].thumbsq) || this.noProductImageUrl();
            }
            return this.noProductImageUrl();
        },
        productImages(product) {
            if(!product || !product.images) return [];
            return product.images
                .filter(img => img && img.type !== 'ambient')
                .map(img => this.sanitizeImageUrls(img));
        },
        hasProductImage(product) {
            return this.productImages(product).length > 0;
        },
        firstProductImage(product) {
            return this.productImages(product)[0] || null;
        },
        toBrl(value){
            if(value !== null && value !== undefined && value !== '') {
                const num = parseFloat(value);
                const isNegative = num < 0;
                let val = Math.abs(num).toFixed(2).toString().replace('.', ',');
                var newVal = ','+val.split(",")[1];
                var charCount=-1;
                const intPart = val.split(",")[0];
                for(let char of intPart.split("").reverse().join("")){
                    if(charCount ===2){
                        newVal = '.'+newVal;
                        charCount=0;
                    }else{
                        charCount++;
                    }
                    newVal = char+newVal;
                }
                return isNegative ? '-'+newVal : newVal;
            }
            return "0,00";
        },
		hasAppliedDiscountValue(discount) {
			if (!discount || discount.value === null || discount.value === undefined || discount.value === '') {
				return false;
			}
			return discount.value.toString().split('+').some(part => parseFloat(part) !== 0);
		},
		hasAnyAppliedDiscountValue(discounts) {
			if (!discounts || !discounts.length) {
				return false;
			}
			return discounts.some(discount => this.hasAppliedDiscountValue(discount));
		},
		getPaymentMethodsColumnWidths(discounts) {
			if (this.hasAnyAppliedDiscountValue(discounts)) {
				return {
					name: '40%',
					discount: '20%',
					installments: '20%',
					total: '20%',
				};
			}
			return {
				name: '50%',
				installments: '30%',
				total: '20%',
			};
		},
		calcDiscountValue(discount, value, increase=0, divideIncrease=false){
        	let total = value;
        	let installmentValue = value;
        	if(discount.value || discount.value===0) {
                total = discount.value.toString().split('+').reduce((accumulator, discValue) => {
                    discValue = parseFloat(discValue);
                    return accumulator - (discount.type === "percent" ? (accumulator * discValue / 100) : discValue);
                }, value);

                installmentValue = total / discount.installments;

                total+=increase;
                installmentValue += divideIncrease?(increase/discount.installments):0;
            }

            return Object.assign({}, discount, {total:total, installmentValue:installmentValue});
        },
		applyTotalToDiscount(discount, base, desiredTotal, increase=0, divideIncrease=false, limitMinValue=null){
			return applyTotalToDiscountUtil(discount, base, desiredTotal, increase, divideIncrease, limitMinValue);
		},
        calcDetailedPrice(price, ignoreMarkup = false){
        	//price = JSON.parse(JSON.stringify(price));
            
            if(price.cost==null && typeof price.cost=='undefined'){
                if(price.value){
                	price.cost = price.value;
				}else{
                    price.cost=0;
				}
            }

            if(!price.increases){
            	Object.assign(price, {increases:{
                    list: [],
                    total:0.0
				}})
			}

            ////console.log(price.increases);

            price.increases.total=parseFloat(price.cost);
            $.each(price.increases.list, function (index, val) {
            	if(!price.increases.list[index].hasOwnProperty('total') || !Number.isFinite(val.total)) {
            		Object.assign(price.increases.list[index], {total:0});
                }

                if(val.type==="percent"){
                    price.increases.list[index].total = +(parseFloat(price.cost)*parseFloat(val.value||"0")/100).toFixed(2);
                }else{
                    ////console.log(val.total);
                    if(!Number.isFinite(val.total)) {
                        ////console.log('Number.isFinite');
                        price.increases.list[index].total = 0;
                    }
                    else {
                        ////console.log('isok');
                        price.increases.list[index].total = +parseFloat(val.value||"0").toFixed(2);
                    }
                }
                price.increases.total+=parseFloat(price.increases.list[index].total);
            });

            ////console.log('increases', price.increases);

            if(!price.discounts){
                Object.assign(price, {discounts:{
                        list: [],
                        total:0.0
                    }})
            }
            price.discounts.total=price.increases.total;
            $.each(price.discounts.list, function (index, val) {
                if(!price.discounts.list[index].hasOwnProperty('total') || !Number.isFinite(val.total))
                    Object.assign(price.discounts.list[index], {total:0});
                if(val.type==="percent"){
                    price.discounts.list[index].total =  +(price.discounts.total*parseFloat(val.value)/100).toFixed(2);
                }else{
                    price.discounts.list[index].total = parseFloat(parseFloat(val.value).toFixed(2));
                }
                price.discounts.total -= price.discounts.list[index].total;
            });

            if(!price.taxes){
                Object.assign(price, {taxes:{
                        list: [],
                        total:0.0
                    }})
            }
            price.taxes.total = price.discounts.total;
            $.each(price.taxes.list, function (index, val) {
                if(!price.taxes.list[index].hasOwnProperty('total'))
                    Object.assign(price.taxes.list[index], {total:0});
                price.taxes.list[index].total = price.taxes.total*parseFloat(val.value)/100;
                price.taxes.total+=price.taxes.list[index].total;
            });

            if(!price.markup){
            	Object.assign(price, {markup:1});
			}
            if(!ignoreMarkup){
                price.value_without_reductions = +(price.taxes.total * parseFloat(price.markup)).toFixed(2);
            }else{
                price.value_without_reductions = price.taxes.total;
			}

            if(!price.reductions){
                Object.assign(price, {reductions:{
                        list: [],
                        total:0.0
                    }})
            }
            price.reductions.total=price.value_without_reductions;
            $.each(price.reductions.list, function (index, val) {
                if(!price.reductions.list[index].hasOwnProperty('total') || !Number.isFinite(val.total))
                    Object.assign(price.reductions.list[index], {total:0});
                if(val.type==="percent"){
                    price.reductions.list[index].total =  +(price.reductions.total*parseFloat(val.value)/100).toFixed(2);
                }else{
                    price.reductions.list[index].total = parseFloat(parseFloat(val.value).toFixed(2));
                }
                price.reductions.total -= price.reductions.list[index].total;
            });

            price.value = price.reductions.total;

			return price;
        },
        guid() {
			function s4() {
				return Math.floor((1 + Math.random()) * 0x10000)
					.toString(16)
					.substring(1);
			}
			return s4() + s4() + s4() + s4() +
				s4();
		},
        isPermissionDefaultAble(module,permission){
	        //adicionar ao array permições que serão habilitadas para todos por default
	        let defaulAbleList=[
	            {
                    module:"product",
                    permission:"update_image",
                },
                {
                    module:"product",
                    permission:"new_category"
                },
                {
                    module:"product",
                    permission:"see_datelhed_price"
                },
                {
                    module:"deal",
                    permission:"create"
                },
                {
                    module:"deal",
                    permission:"update_sold"
                },
                {
                    module:"client",
                    permission:"view"
                }
            ];
            let isInArray=defaulAbleList.find(x => x.module === module && x.permission===permission);
            if(isInArray && typeof this.global.company.settings.permissions[module][permission] === 'undefined') {
                return true;
            }
            else{
                return false;
            }
        },

        hasProduct(product) {
			let self = this;
            let found = 0;
			let company = self.global.company;

            /* GAMBIARRA */
            if (company.subscription && company.subscription.plan && company.subscription.plan.code) {
                if (company.subscription.plan.code.includes('hoopcrm') || company.subscription.plan.code.includes('marketing')) {
                    found = true;
                }
            }

            return found;

            ////console.log("hasProduct", company);
            /*

            if(company.subscription && company.subscription.product_items && Array.isArray(company.subscription.product_items)) {
                company.subscription.product_items.forEach(element => {
                    var result = product.localeCompare(element.product.code);
                    ////console.log(element.product.code, product, result);
                    if(result==0) {
                        found = true;
                    }
                });
            }

            return found;
            */
        },

		hasPermissionInCompany(module, permission){
			let self = this;
			let company = self.global.company;
			let user = self.global.user;

			if(!company || !company.settings || !company.settings.permissions || !company.pivot){
				return false;
			}

			if(company.settings && company.settings.permissions){

                if(this.isPermissionDefaultAble(module,permission)){
                    return true;
                }
				let permissions = company.settings.permissions;
				let role = company.pivot ? company.pivot.role : null;

                if(role=='manufacturer' || role=='superadmin') 
                    return true;

                // Default restrito (igual Company::defaultPermissions): manager liberado se a chave ainda não existir na loja
                if (module === 'deal' && permission === 'manage_loss_win_reasons'
                    && role === 'manager'
                    && !(permissions.deal && permissions.deal.manage_loss_win_reasons)) {
                    return true;
                }

                if (module === 'import' && permission === 'revert'
                    && role === 'manager'
                    && !(permissions.import && permissions.import.revert)) {
                    return true;
                }

				if(role &&permissions[module] &&permissions[module][permission] &&permissions[module][permission][role].hasPermission){
					return true;
				}

                // Fallback legado: configs de PM usavam update antes de manage_boards/manage_catalogs
                if (
                    role &&
                    (permission === 'manage_boards' || permission === 'manage_catalogs') &&
                    permissions[module] &&
                    !permissions[module][permission] &&
                    permissions[module].update &&
                    permissions[module].update[role] &&
                    permissions[module].update[role].hasPermission
                ) {
                    return true;
                }
			}
			return false;
		},

		walletPermissionKey(ownerType, action) {
			const map = {
				especificador: {
					view: 'view_architect',
					add_credit: 'add_credit_architect',
					withdraw: 'withdraw_architect',
					generate_accounts_payable: 'generate_accounts_payable_architect',
				},
				vendedor: {
					view: 'view_seller',
					add_credit: 'add_credit_seller',
					withdraw: 'withdraw_seller',
					generate_accounts_payable: 'generate_accounts_payable_seller',
				},
				cliente: {
					view: 'view_client',
					add_credit: 'add_credit_client',
					withdraw: 'withdraw_client',
				},
			};
			return map[ownerType] && map[ownerType][action] ? map[ownerType][action] : null;
		},

		hasWalletPermission(ownerType, action) {
			if (action === 'view' || !ownerType) {
				if (!this.hasPermissionInCompany('wallet', 'view')) {
					return false;
				}
				if (!ownerType && action === 'view') {
					return true;
				}
			}
			const key = this.walletPermissionKey(ownerType, action);
			if (!key) {
				return false;
			}
			if (action !== 'view' && !this.hasPermissionInCompany('wallet', 'view')) {
				return false;
			}
			if (action !== 'view' && !this.hasPermissionInCompany('wallet', this.walletPermissionKey(ownerType, 'view'))) {
				return false;
			}
			return this.hasPermissionInCompany('wallet', key);
		},

		/**
		 * Preferência pessoal (users.settings.auto_filter_seller): ao abrir Lista/Funil/Agenda,
		 * pré-seleciona o filtro do usuário logado. Útil com "Pode ver todos os negócios".
		 */
		wantsAutoFilterSeller(){
			const settings = this.global && this.global.user && this.global.user.settings;
			return !!(settings && settings.auto_filter_seller);
		},
        hasPrivateCatalog(){
            let self = this;
            let company = self.global.company;

            if(company.settings && company.settings.catalog){
                if(company.settings.catalog.visibility === 'private'){
                    return true;
                }
            }
            return false;
        },
		hasAccessToModule(module, company){
			let architectModules = ['project', 'catalog', 'network', 'networkArch', 'quotations', 'offers'];
			let storeModules = ['deal', 'catalog', 'network', 'networkStore', 'tasks', 'offers', 'reports'];
            let industryModules = ['deal', 'catalog', 'network', 'networkStore', 'tasks'];
			let serviceModules = ['deal', 'network'];

			if(company) {

				if(company.type === 'store'){
					return storeModules.indexOf(module)!=-1;
                }else if (company.type === 'industry'){
                    return industryModules.indexOf(module)!=-1;
				}else if (company.type === 'office'){
	                return architectModules.indexOf(module)!=-1;
				}else if (company.type === 'service_supplier'){
	                return serviceModules.indexOf(module)!=-1;
				}

			} else {
				return false;
			}
		},
        myPlanCan(module, plan) {

            if(plan=='plan_hoopdecor' || plan=='plan_hoopdecor_pos') {
                plan = 'plano_loja_pro';
            }

            if(plan=='plan_hoopcrm' || plan=='plan_hoopcrm_pos' || plan=='plano_combo_loja_pro_marketing_pos') {
                plan = 'plano_combo_loja_pro_marketing';
            }

            if($.inArray(plan, plans_features[module]) !== -1) {
                return true;
            } else {
                return false;
            }

        },
        myRoleCan(what, role) {

            switch (role) {

                case 'marketing':

                        if(what=='campaigns')
                            return true;
                        else
                            return false;

                        break;

                case 'cashier':

                        if(what=='coupons')
                            return true;
                        else
                            return false;

                        break;


                default:
                        return true;
            }         

        },

        hasPlan(planCode){
            return this.global.company.subscription.plan.code === planCode;
        },
        applySessionEstoreId(dealForm) {
            const currentStore = this.$root.currentStore;
            if (currentStore && currentStore.id && dealForm && dealForm.data) {
                dealForm.data.estore_id = currentStore.id;
            }
        },
        applyDefaultExpireAt(dealForm) {
            if (!dealForm || !dealForm.data) {
                return;
            }
            const current = dealForm.data.expire_at;
            if (current !== null && current !== undefined && current !== '') {
                return;
            }
            const settings = this.global && this.global.company && this.global.company.settings && this.global.company.settings.deal;
            const days = settings && settings.expire_at;
            if (!days) {
                return;
            }
            const daysNum = parseInt(days, 10);
            if (!daysNum || daysNum <= 0) {
                return;
            }
            dealForm.data.expire_at = moment().add(daysNum, 'days').format();
        },
        applyDefaultSaleOriginType(dealForm) {
            if (!dealForm || !dealForm.data) {
                return;
            }
            const settings = this.global && this.global.company && this.global.company.settings && this.global.company.settings.deal;
            if (!settings || !settings.enable_sale_origin_type) {
                dealForm.data.sale_origin_type = null;
                return;
            }
            dealForm.data.sale_origin_type = settings.default_sale_manufacturing
                ? 'manufacturing'
                : 'stock';
        },
        /**
         * Na UI, null aparece como desmarcado (= estoque). Ao salvar com a feature ativa,
         * materializa null/inválido como 'stock'.
         */
        ensureSaleOriginTypeForSave(dealForm) {
            if (!dealForm || !dealForm.data) {
                return;
            }
            const settings = this.global && this.global.company && this.global.company.settings && this.global.company.settings.deal;
            if (!settings || !settings.enable_sale_origin_type) {
                return;
            }
            if (dealForm.data.sale_origin_type !== 'manufacturing' && dealForm.data.sale_origin_type !== 'stock') {
                dealForm.data.sale_origin_type = 'stock';
            }
        },
	    mix_checkUrlKey(urlkey, table, type = '') {

	    	var self = this;

	        return new Promise(function(resolve, reject) {

		        axios.get('/api/urlkey?api_token='+self.global.user.api_token+'&company_logged='+self.global.company.id+'&table='+table+'&urlkey='+urlkey+'&type='+type)
		        .then((data) => {
                    let urlkeyWithoutBreakLine = data.data.replace(/\n/g,'');
                    urlkeyWithoutBreakLine = urlkeyWithoutBreakLine.replace(/\r/g,'');
		            if(urlkeyWithoutBreakLine==urlkey){
		                resolve(true);
		            }
		            else if(data.data == "invalid00"){
		            	reject("Caractere inválido, pontos(.) e underlines(-) não são aceitos.");
		            }
		            else {
		            	reject("Urlkey já está em uso.");
		            }
		        })
		        .catch(errors => {
		        	alert(errors);
		        });

	        });
	    },
	    mix_createUrlKey(title, separator) {

			if(typeof separator == 'undefined') separator = '-';

			// Convert all dashes/underscores into separator
			var flip = separator == '-' ? '_' : '-';
			title = title.replace(flip, separator);

			// Remove all characters that are not the separator, letters, numbers, or whitespace.
			title = title.toLowerCase()
					.replace(new RegExp('[^a-z0-9' + separator + '\\s]', 'g'), '');

			// Replace all separator characters and whitespace by a single separator
			title = title.replace(new RegExp('[' + separator + '\\s]+', 'g'), separator);

			return title.replace(new RegExp('^[' + separator + '\\s]+|[' + separator + '\\s]+$', 'g'),'');
	    },
        /**
         * Generates a unique identifier based on the current timestamp, prefix, and a set of characters.
         * The generated id is a string of length 9, starting with the first three characters of the prefix.
         * The following characters are obtained by alternating between the characters of the current timestamp
         * and random characters from the set of characters.
         * @param {string} prefix - The prefix to be used to generate the unique identifier.
         * @returns {string} A unique identifier of length 9 based on the current timestamp and prefix.
         */
        productUniqueId(prefix) {
            var d = new Date().valueOf();
            var n = d.toString();
            var result = prefix.toString().substring(0, 3);
            var length = 9;
            var p = 0;
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            // bold for illustration
            for (var i = length; i > 0; --i){
                result += ((i & 1) && n.charAt(p) ? n.charAt(p) : chars[Math.floor(Math.random() * chars.length)]);
                if(i & 1) p++;
            };

            // check if the result contains at least one number and one letter
            var hasNumber = result.match(/\d+/);
            var hasLetter = result.match(/[a-zA-Z]/);
            if(!hasNumber || !hasLetter){
                result = '';
                for (var i = length; i > 0; --i){
                    result += chars[Math.floor(Math.random() * chars.length)];
                };
            }
            return result;
        },
		genProjectCode(item, alreadyCreatedCodes = []){
        	let code = '';
			let categoryMinDepth = item.categories.reduce((min, cat)=>Math.min(min, cat.depth),999999999);
			let cat = item.categories.find(cat=>cat.depth === categoryMinDepth);
			if(cat)
				code+=cat.name;
			else
				code+='SEM-CATEGORIA';

			code+='_';


			if(item.section) {
                code += item.section.replace(/ /g, "-");
            }else
				code+='SEM_AMBIENTE_DEFINIDO';

			let end = alreadyCreatedCodes.filter(c=>c.includes(code)).reduce((end, c)=>{
				let splited = c.split(code+'_');
				if(splited.length>1){
					return Math.max(end, 1+parseInt(splited[1]));
				}else{
					return 1;
				}
			}, 0);

			if(end)
				code+='_'+end;

			return code;
		},
        getCompanyTypeLabel(company){
            switch(company.type){
				case 'office':
					return 'Escritório';
				case 'industry':
					return 'Fábrica';
				case 'service_supplier':
					return 'Prestador de Serviços';
				default:
					return 'Loja';
            }
        },
        searchZipCode(address){
            if(address.zipcode.replace('-', '').replace('_', '').length !==8){
                console.error("CEP inválido");
            }else{
				EventBus.$emit('isLoadingGeneral', true);
				axios.get('/api/viacep/'+address.zipcode, {})
					.then(response => {
						address.address = response.data.logradouro;
						address.city = response.data.localidade;
						address.state = response.data.uf;
						EventBus.$emit('isLoadingGeneral', false);
					})
					.catch(errors =>{
						//console.log(errors);
						EventBus.$emit('isLoadingGeneral', false);
					});
            }
        },
        productToBudget(){
	          this.item.quantity = 1;
	          this.item.section = 'SEM AMBIENTE DEFINIDO';
	          this.item.client_obs = "";
	          var budgetProducts = JSON.parse(this.$localStorage.get('budgetProducts'));
	          if(budgetProducts == null){
	              budgetProducts = [];
	          }
	          budgetProducts.push(this.item);
	          this.$localStorage.set('budgetProducts', JSON.stringify(budgetProducts));
	          EventBus.$emit('watchBudgetProducts');
	          EventBus.$emit('toastShow', 'produto inserido');
        },
        stringToURL(val){
        	var conversions = new Object();
			conversions['ae'] = 'ä|æ|ǽ';
			conversions['oe'] = 'ö|œ';
			conversions['ue'] = 'ü';
			conversions['Ae'] = 'Ä';
			conversions['Ue'] = 'Ü';
			conversions['Oe'] = 'Ö';
			conversions['A'] = 'À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ';
			conversions['a'] = 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª';
			conversions['C'] = 'Ç|Ć|Ĉ|Ċ|Č';
			conversions['c'] = 'ç|ć|ĉ|ċ|č';
			conversions['D'] = 'Ð|Ď|Đ';
			conversions['d'] = 'ð|ď|đ';
			conversions['E'] = 'È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě';
			conversions['e'] = 'è|é|ê|ë|ē|ĕ|ė|ę|ě';
			conversions['G'] = 'Ĝ|Ğ|Ġ|Ģ';
			conversions['g'] = 'ĝ|ğ|ġ|ģ';
			conversions['H'] = 'Ĥ|Ħ';
			conversions['h'] = 'ĥ|ħ';
			conversions['I'] = 'Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ';
			conversions['i'] = 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı';
			conversions['J'] = 'Ĵ';
			conversions['j'] = 'ĵ';
			conversions['K'] = 'Ķ';
			conversions['k'] = 'ķ';
			conversions['L'] = 'Ĺ|Ļ|Ľ|Ŀ|Ł';
			conversions['l'] = 'ĺ|ļ|ľ|ŀ|ł';
			conversions['N'] = 'Ñ|Ń|Ņ|Ň';
			conversions['n'] = 'ñ|ń|ņ|ň|ŉ';
			conversions['O'] = 'Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ';
			conversions['o'] = 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º';
			conversions['R'] = 'Ŕ|Ŗ|Ř';
			conversions['r'] = 'ŕ|ŗ|ř';
			conversions['S'] = 'Ś|Ŝ|Ş|Š';
			conversions['s'] = 'ś|ŝ|ş|š|ſ';
			conversions['T'] = 'Ţ|Ť|Ŧ';
			conversions['t'] = 'ţ|ť|ŧ';
			conversions['U'] = 'Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ';
			conversions['u'] = 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ';
			conversions['Y'] = 'Ý|Ÿ|Ŷ';
			conversions['y'] = 'ý|ÿ|ŷ';
			conversions['W'] = 'Ŵ';
			conversions['w'] = 'ŵ';
			conversions['Z'] = 'Ź|Ż|Ž';
			conversions['z'] = 'ź|ż|ž';
			conversions['AE'] = 'Æ|Ǽ';
			conversions['ss'] = 'ß';
			conversions['IJ'] = 'Ĳ';
			conversions['ij'] = 'ĳ';
			conversions['OE'] = 'Œ';
			conversions['f'] = 'ƒ';

			val = val.replace('/','');
			val = val.toLowerCase();
			for(var i in conversions){
			    var re = new RegExp(conversions[i],"g");
			    val = val.replace(re,i);
			}
			val = val.replace(/ /g, "-");
			return val;
        },
		openInNewTab(url) {
		    var win = window.open(url, '_blank');
		    win.focus();
		},
		isElegible(cb){
            cb(false);
        },
		redirectToModule(){
            switch (this.global.company.subscription.plan.code) {
                case 'plano_loja_pro':
                	this.$router.replace('/negocios');
                	break;
                case 'plano_fabrica_pro':
                	this.$router.replace('/negocios');
                	break;
                case 'plano_loja_free':
                	// EventBus.$emit('show_store_free_dashboard');
                    EventBus.$emit('show_context_dashboard');
                    break;
                case 'plano_context':
                    EventBus.$emit('show_context_dashboard');
                    break;
                case 'plano_arquiteto_free':
                    this.$router.replace('/guia-de-inspiracoes/home');
                    break;
                default:
                	this.$router.replace('/catalogo');
                	break;
            }
		},
		companyTypeName(){
        	switch(this.global.company.type){
				case 'store':
					return 'Loja';
					break;
				case 'office':
					return 'Escritório';
					break;
				case 'industry':
					return 'Fábrica';
					break;
			}
		},
		mix_delay(ms) {
		    var timer = 0;
		    return function(callback){
		        clearTimeout (timer);
		        timer = setTimeout(callback, ms);
		    };
		},
		download(link, name = 'orçamento'){
            let anchor = document.createElement('a');
            anchor.href = link;
            anchor.target = '_blank';
            anchor.download = name;
            anchor.click();
		},
		clearProduct(product){
            let clearedProduct = ['created_at', 'deleted_at', 'updated_at', 'cest', 'created_by', 'group', 'gtin', 'gtin_package', 'hidden', 'ipi', 'ncm', 'origin', 'parent_id', 'user_id', 'verified',
            	'urlkey', 'categories.*.active', 'categories.*.created_at', 'categories.*.deleted_at', 'categories.*.updated_at', 'categories.*.description'
				, 'categories.*.lft', 'categories.*.pivot', 'categories.*.rgt', 'categories.*.urlkey', 'categories.*.visibility', 'company', 'manufacturer.catalog_password', 'manufacturer.created_at'
				, 'manufacturer.deleted_at', 'manufacturer.updated_at', 'manufacturer.erp', 'manufacturer.extradata', 'manufacturer.group', 'manufacturer.metas', 'manufacturer.receitaws', 'manufacturer.settings', 'manufacturer.subscription'
				, 'manufacturer.superlogica_id', 'manufacturer.urlkey', 'manufacturer.user_id', 'manufacturer.vindi_id', 'manufacturer.website', 'images.*.created_at', 'images.*.updated_at'
				, 'images.*.deleted_at', 'images.*.disk','images.*.external', 'images.*.user_id', 'images.*.imageable_type', 'images.*.imageable_id', 'images.*.order'
                , 'service_supplier.catalog_password', 'service_supplier.created_at' , 'service_supplier.deleted_at', 'service_supplier.updated_at', 'service_supplier.erp'
				, 'service_supplier.extradata', 'service_supplier.group', 'service_supplier.metas', 'service_supplier.receitaws', 'service_supplier.settings', 'service_supplier.subscription'
				, 'service_supplier.superlogica_id', 'service_supplier.urlkey', 'service_supplier.user_id', 'service_supplier.vindi_id', 'service_supplier.website', 'manufacturer.logo'
                , 'manufacturer.logo', 'manufacturer.email', 'manufacturer.iugu_id', 'manufacturer.ie', 'manufacturer.partner_id', 'manufacturer.blocked', 'manufacturer.webhooks_updated_at'
                , 'manufacturer.hasErpIntegration', 'manufacturer.erpInfo', 'categories.*.parent_id', 'categories.*.depth', 'categories.*.external_id', 'categories.*.ecommerce_id'
                , 'categories.*.area_of_interest', 'categories.*.company_id', 'batch.created_at', 'batch.deleted_at', 'batch.updated_at', 'batch.company_id', 'attribute_option_ids'
			].reduce((product, key)=>{
                //delete product[key];
				this.deleteObjectProperty(product, key);
				return product;
            },product);
            //clear product prices
            clearedProduct.prices.splice(1, clearedProduct.prices.length-1)
            if (Array.isArray(clearedProduct.images)) {
                clearedProduct.images = clearedProduct.images.map(image => this.sanitizeImageUrls(image));
            }
            if (clearedProduct.product && Array.isArray(clearedProduct.product.images)) {
                clearedProduct.product.images = clearedProduct.product.images.map(image => this.sanitizeImageUrls(image));
            }
            return clearedProduct;
		},
		policyCheck_createQuotation() {
            if(!this.hasPermissionInCompany('deal','create')){
                alert('Você não possui permissão para criar novos orçamentos');
                return;
            }

			if(this.policy_canIdoThis('create_quotation')) {
				this.$router.push('/negocios/criar');
			} else {
				EventBus.$emit('openPlansModal');
			}
		},
		policy_canIdoThis(action) {

            return true;
			switch(action) {
				case 'create_quotation':
					if(this.global.company.subscription.plan!=='plano_loja_pro') {
						return false;
					} else {
						return true;
					}
					break;

				default:
					return false;
					break;
			}
		},
		percentageMax(val){
			if(val!==''){
                val=val+'';
                return val.split('+').reduce((fullVal, discountValue, index)=>{
                    let separator = index>0?'+':'';
                    let val = 100;
                    if(discountValue && parseFloat(discountValue) < 100){
                        val = parseFloat(discountValue);
                        if(discountValue[discountValue.length-1]==='.')
                            val+='.';
                    }
                    return fullVal + separator + val;
				}, "");
			}
			return 0;
		},
		onlyInt(val){
			if(val!=='' && !isNaN(parseInt(val))){
				return parseInt(val);
			}
			return 0;
		},
		downloadAttachments(item){
            item.files.forEach(file=>this.download(file.file_path));
		},
		generateHyperlinks(text) {
		    var urlRegex = /(http|https|ftp|ftps)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?/g;
		    return text.replace(urlRegex, function(url) {
		        return '<a target="_blank" style="word-break: break-all;" href="' + url + '">' + url + '</a>';
		    });
		},
        firstUnconcludedItem(isStage = false){
            var completed, currentStep = {};
            if(this.global.company.type === 'office'){
                completed = this.global.user.extradata.walk_me.office.progress.completed_steps;
            } else{
                completed = this.global.user.extradata.walk_me.store_free.progress.completed_steps;
            }
            this.global.ongoingTutorial.info.stages.forEach(function(stage){
                completed = completed - stage.steps.length;
                if(completed < 0){
                	if(isStage){
                        currentStep = stage.name;
					}
					else{
                    	currentStep = stage.steps[completed + stage.steps.length];
                    }
                    completed = 999;
                }
            });
            return currentStep;
        },
        getAndRouteToNextStage(isRouting = true, openModal = false){
        	Vue.set(this.global.ongoingTutorial, 'currentStep', this.firstUnconcludedItem());
        	// store_free
            if(this.global.ongoingTutorial.currentStep.action === 'show_modal'){
                EventBus.$emit('show-tutorial-store_free');
                this.$router.replace('/');
            }
        	// office
        	if(this.global.ongoingTutorial.currentStep.action === ':shift:'){
        		this.global.ongoingTutorial.currentStep.action = this.global.ongoingTutorial.currentStep.actions.shift();
			}
            if(this.global.ongoingTutorial.currentStep.route && isRouting){
            	var index = this.global.ongoingTutorial.currentStep.route.indexOf(":id:"), route = this.global.ongoingTutorial.currentStep.route;
            	if(index !== -1){
					route = route.replace(":id:", this.global.user.extradata.walk_me.office.project_id);
				}
				this.$router.replace(route);
			}
			else if(this.global.ongoingTutorial.currentStep.action === 'init'){
                EventBus.$emit('show-walk-me-office');
                this.$router.replace('/');
            }
            if(openModal && (this.global.ongoingTutorial.currentStep.action === 'save_product' || this.global.ongoingTutorial.currentStep.action === 'create_product')){
                EventBus.$emit('openModalInsertNewProduct');
            }
            if(openModal && this.global.ongoingTutorial.currentStep.action === 'printing_configuration'){
                EventBus.$emit('openModalPrintingConfiguration');
            }
		},
        processExtradataTutorial(routeId = 0, inc = 1, endOnboarding = false){
            var self = this;
            if(this.global.company.type === 'office'){
                self.global.user.extradata.walk_me.office.progress.completed_steps += inc;
                if(routeId !== 0){
                    self.global.user.extradata.walk_me.office.project_id = routeId;
                }
                if(self.global.user.extradata.walk_me.office.progress.completed_steps >= 15 || endOnboarding === true){
                    self.global.user.extradata.walk_me.office.done = true;
                }
            } else{
                self.global.user.extradata.walk_me.store_free.progress.completed_steps += inc;
                if(self.global.user.extradata.walk_me.store_free.progress.completed_steps >= 0 || endOnboarding === true){
                    self.global.user.extradata.walk_me.store_free.done = true;
                }
            }
        },
        processTutorialStage(routeid = 0, endOnboarding = false){
            var self = this;
            if(this.global.company.type === 'office'){
                if(self.global.user.extradata.walk_me.office.done && (self.global.user.extradata.walk_me.office.progress.completed_steps >= 15) || endOnboarding){
                    this.global.ongoingTutorial.currentStep = null;
                    this.global.ongoingTutorial.info = null;
                    EventBus.$emit('end-walk-me-office');
                }
                if(!self.global.user.extradata.walk_me.office.done){
                    if(routeId !== 0){
                        this.getAndRouteToNextStage(false);
                        self.$router.replace('/projetos/' + routeId + '/geral');
                    }
                    else{
                        this.getAndRouteToNextStage();
                    }
                }
            }
        },
        saveTutorialProgress(routeId = 0, inc = 1, endOnboarding = false){
            var self = this;
            this.processExtradataTutorial(routeId = 0, inc = 1, endOnboarding = false);
            EventBus.$emit('isLoadingGeneral', true);
            axios.post('/api/users/'+self.global.user.id+'/extradata', {
                api_token:self.global.user.api_token,
                extradata:self.global.user.extradata,
            })
                .then(response=>{
                    EventBus.$emit('isLoadingGeneral', false);
                    this.processTutorialStage(routeId, endOnboarding);
                })
                .catch(error=>{
                    //console.log(error);
                });
        },
        getHost(isPortfolio = false){
	        switch(this.global.environment){
                case 'local':
                    return "http://"+(isPortfolio ? "guia." : "")+"hoopdecor.local/";
                case 'staging':
                    return "https://"+(isPortfolio ? "guia" : "dev")+".hoopdecor.com/";
                case 'production':
                    return "https://"+(isPortfolio ? "guia" : "www")+".hoopdecor.com/";
            }
        },
        saveAction(action){
            var self = this;
            axios.post('/api/actions', {
                name: action.name,
                type: action.type,
                actionable_id: action.actionable_id,
                actionable_type: action.actionable_type,
                extradata: action.extradata,
            }).then(response=>{
                //console.log(response.data);
            }).catch(error=>{
                //console.log(error);
            });
        },

        percentage( value, max ){
            let percentage = 0
            if(max!==0) percentage = value * 100 / max
            return percentage.toFixed(2)
        },

        isFromFidelityProgram(companyId){
            return companiesOfFidelityProgram.includes(companyId)
        },

        isCimcal() {
            if(!this.global) return false;
            if(this.global.company && this.global.company.id === 15840 || this.global.company.group === 15840 || (this.global.company.hasErpIntegration && this.global.company.erpInfo.name === 'cimcal')) {
                //console.log('CIMCAL');
                return true;
            } else {
                return false;
            }
        },
        companyCurrency(){
            let company = this.global && this.global.company ? this.global.company :  this.company;
            if(company && company.settings)
                return company.settings.company.currency ? company.settings.company.currency : 'R$';
            else
                return 'R$';
        },
        removeHTML(description){
            if(!description || !description.length )
                return '';
            const temp = document.createElement('div');
            temp.innerHTML = description;
            return temp.textContent || temp.innerText || '';
        },
        hasHtmlMarkup(value){
            return typeof value === 'string' && /<[a-z!\/][^>]*>/i.test(value);
        },
        isCalendarTaskDescription(description){
            if (!this.hasHtmlMarkup(description)) {
                return false;
            }
            return /<b>\s*(?:Descrição|Cliente|Loja)\s*:?\s*<\/b>/i.test(description)
                || /Atividade na Hoop/i.test(description);
        },
        plainTextFromHtml(value){
            if (!value) {
                return '';
            }
            let text = String(value);
            if (!this.hasHtmlMarkup(text)) {
                return text.replace(/\s+/g, ' ').trim();
            }
            text = text.replace(/<(br|\/p|\/div|\/li|\/tr|\/h[1-6])[^>]*>/gi, ' ');
            text = this.removeHTML(text);
            return text.replace(/\s+/g, ' ').trim();
        },
        plainTaskDescription(description){
            if (!description) {
                return '';
            }
            let html = String(description);
            if (this.isCalendarTaskDescription(html)) {
                let userPart = '';
                const withCliente = html.match(/<b>\s*Descrição:\s*<\/b>\s*(?:<br\s*\/?\s*>)*([\s\S]*?)(?:<br\s*\/?\s*>)*\s*<b>\s*Cliente\s*<\/b>/i);
                const withLoja = html.match(/<b>\s*Descrição:\s*<\/b>\s*(?:<br\s*\/?\s*>)*([\s\S]*?)(?:<br\s*\/?\s*>)*\s*<b>\s*Loja\s*<\/b>/i);
                if (withCliente) {
                    userPart = withCliente[1];
                } else if (withLoja) {
                    userPart = withLoja[1];
                } else if (/^<span>/i.test(html)) {
                    const parts = html.split(/<br\s*\/?\s*>/i);
                    userPart = parts.length > 1 ? parts[1] : '';
                }
                html = userPart;
            }
            return this.plainTextFromHtml(html);
        },
        plainTaskTitle(title, description){
            if (!title) {
                return '';
            }
            let result = String(title);
            if (this.isCalendarTaskDescription(description)) {
                const lastDash = result.lastIndexOf('-');
                if (lastDash > 0) {
                    result = result.substring(0, lastDash).trim();
                }
            }
            return result;
        }
	},

    computed:{
	    customProductOwnerId(){
            let company = this.global.company;
            if(company.group){
                return company.group;
            }else{
                return company.id;
            }
        }
    }

};

export { mix_general };
